<template>
    <div class="white-box white-box-no-tab text-base xs:text-lg pb-10">
        <Title
            styleBase
            :text="$route.meta.pageTitle"
        />
        <ul class="text-tip">
            <li>每次申請僅能授權一張保單。</li>
            <li>
                本項服務為線上授權以金融機構帳戶扣款繳交保單之保險費及保險單借款利息(限授權要保人之金融機構帳戶)。
            </li>
        </ul>
        <h4 class="py-3 md:pb-3.5 md:pt-5 border-t border-solid">
            請選擇電子化授權方式
        </h4>
        <div class="grid grid-cols-2 gap-x-3 md:gap-x-6 lg:gap-x-8">
            <Card
                v-if="onlineBank.length> 0"
                class="col-span-2 sm:col-span-1"
                @click.prevent="goNext(applyWay[0])"
            >
                <template #input>
                    <div class="flex items-end">
                        <SvgIcon
                            icon-name="monitor-gray-900"
                            class="w-9 h-9 mr-4"
                        />
                        <span>{{ applyWay[0].name }}</span>
                    </div>
                </template>
                <template #content>
                    <div class="px-1">
                        <div>
                            保費授權人輸入轉帳扣款帳戶之網路銀行登入相關資料 (包括身分證統一編號、使用者代號、使用者密碼及驗證碼等資料)，由扣款銀行進行身分驗證。
                        </div>
                        <div class="text-right mt-4">
                            <div
                                class="inline-block px-2.5 -mr-2.5"
                                @click.prevent.stop="openModal(onlineBank, applyWay[0].name)"
                            >
                                <button class="btn-text text-primary border-b border-primary text-[1rem] disabled:text-gray-400 disabled:border-gray-400">
                                    適用銀行
                                </button>
                            </div>
                        </div>
                    </div>
                </template>
            </Card>
        </div>
        <Loading :isLoading="isLoading" />
    </div>
</template>

<script>
import { inject, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Title from '@/components/text/Title.vue';
import Card from './Card.vue';
import routeName from '@/router/constant.js';
import { getBankListACH } from '@/apis/aplCatlACH.js';
import Loading from '@/components/Loading.vue';
import codeList from '@/json/codeList';
import typeListACH from '@/json/typeListACH';

export default {
    components: {
        Title,
        Card,
        Loading
    },
    setup() {
        const $vfm = inject('$vfm');
        const store = useStore();
        const router = useRouter();
        const visiblePopup = ref(false);
        const onlineBank = ref([]);
        // OnlineBank=網銀帳號密碼驗證
        const isLoading = ref(false);
        const applyWay = ref(typeListACH);
        const openModal = (list, name) => {
            const params = {
                title: `${name}-適用銀行`,
                content: list.map(i => i.bankName).join('、') || '暫無資料',
                confirmButton: '確定',
                closeicon: true,
            };
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                    },
                    closed() {
                        $vfm.hide('DialogBase');
                    }
                }
            });
        };

        const operationDesc = () => {
            visiblePopup.value = true;
        };

        // 取得可驗證銀行列表，輸入參數type
        const getBankList = (applyObject) => {
            return getBankListACH(applyObject.type).then(res => {
                return res.data?.achBankList;
            });
        };

        const getData = async () => {
            isLoading.value = true;
            onlineBank.value = await getBankList(applyWay.value[0]);
            isLoading.value = false;
        };
        getData();

        const goNext = (applyObject) => {
            store.dispatch('services/setChangeItemsResult', { code: `${codeList.ACH}applyWay`, value: applyObject });
            router.push({ name: routeName.AUTH_POLICY }).catch(err => { console.log(err); });
        };

        return {
            openModal,
            operationDesc,
            goNext,
            onlineBank,
            applyWay,
            visiblePopup,
            isLoading
        };
    },
};
</script>
